<template>
    <div class="condition flex-con sm-pad-lr is-start">
        <div>
            <div class="field has-addons">
                <div
                    class="control"
                    v-if="activeField"
                >
                    <div class="button is-static">
                        {{activeField.group}}
                    </div>
                </div>
                <div class="control">
                    <div
                        class="select"
                        :class="{ 'is-danger' : errors.has(fieldFormName) }"
                    >
                        <select
                            :value="activeCondition.fieldHandle"
                            :name="fieldFormName"
                            v-validate="'required'"
                            @change="fieldChanged($event.target.value)"
                        >
                            <optgroup
                                v-for="group in groupedFields"
                                :key="group.groupName"
                                :label="group.groupName"
                            >
                                <option
                                    v-for="field in group.fields"
                                    :key="field.handle"
                                    :value="field.handle"
                                >
                                    {{field.nameNoPrefix}}
                                </option>
                            </optgroup>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!customTypeConditionComponent && dataTypeComparatorsKeys.length !== 1">
            <div
                v-if="!dataTypeComparators"
                class="select-a-field"
            >
                <i class="fa fa-arrow-circle-o-left"></i> Select a field
            </div>
            <div
                v-else
                class="select"
                :class="{ 'is-danger' : errors.has(comparatorFormName) }"
            >
                <select
                    v-model="activeCondition.comparatorHandle"
                    :name="comparatorFormName"
                    v-validate="'required'"
                    @change="$emit('update', activeCondition)"
                >
                    <option
                        v-for="comparator in dataTypeComparators"
                        :key="comparator.handle"
                        :value="comparator.handle"
                    >
                        {{comparator.label}}
                    </option>
                </select>
            </div>
        </div>
        <component
            ref="customCondition"
            v-if="customTypeConditionComponent"
            :is="customTypeConditionComponent"
            :value="activeCondition"
            :field="activeField"
            :form-name="conditionFormName"
            @input="activeCondition = $event"
            v-on:enter="$emit('enter')"
        />
        <div v-else-if="activeCondition.comparatorHandle">
            <component
                :is="valueComponent"
                :options="activeField.options"
                :form-name="conditionFormName"
                v-model="activeCondition.condition"
                @input="activeCondition.condition = $event"
                v-on:enter="$emit('enter')"
                ref="valueComponent"
            ></component>
        </div>
    </div>
</template>

<script>
import {defaults, findWhere} from 'underscore';
export default {
    name : "Condition",
    inject : ['$validator'],
    data () {
        return {
            activeCondition : Object.assign({}, defaults({...this.condition}, {
                fieldHandle : null,
                comparatorHandle : null,
                condition : {
                    value : null,
                },
            })),
        };
    },
    props : {
        condition : {
            type : Object,
            required : false,
        },
        uniqueId : {
            type : String,
            required : true,
        },
        availableFields : {
            type : Object,
            required : true,
        },
    },
    watch : {
        activeCondition : {
            immediate : true,
            deep : true,
            handler (activeCondition) {
                this.$emit('updated', activeCondition);
            },
        },
    },
    computed : {
        groupedFields () {
            return this.availableFields.groupedFields;
        },
        activeField () {
            return this.availableFields.fields.find(f => f.handle === this.activeCondition.fieldHandle);
        },
        customTypeConditionComponent () {
            return this.activeField && this.activeField.type.customTypeCondition;
        },
        dataTypeComparators () {
            const field = this.activeField;
            if(!field){
                return;
            }
            return field.overrideComparators ? field.overrideComparators : field.type.comparators;
        },
        dataTypeComparatorsKeys () {
            return !this.dataTypeComparators ? [] : Object.keys(this.dataTypeComparators);
        },
        activeComparator () {
            const comparators = this.dataTypeComparators;
            if(!comparators){
                return;
            }
            return findWhere(comparators, { handle : this.activeCondition.comparatorHandle });
        },
        valueComponent () {
            if(this.activeField && this.activeField.filterComponent){
                return this.activeField.filterComponent;
            }
            const comparator = this.activeComparator;
            if(comparator){
                return comparator.comparatorComponent;
            }
            return null;
        },
        fieldFormName () {
            return `field-${this.uniqueId}`;
        },
        comparatorFormName () {
            return `comparator-${this.uniqueId}`;
        },
        conditionFormName () {
            return `condition-${this.uniqueId}`;
        },
        isValid () {
            return this.activeCondition.fieldHandle && this.activeCondition.comparatorHandle && (this.valueComponent === null || this.activeCondition.condition.value !== null);
        },
    },
    methods : {
        fieldChanged (handle) {
            this.activeCondition.fieldHandle = handle;
            if(this.dataTypeComparatorsKeys.length) {
                this.activeCondition.comparatorHandle = this.dataTypeComparators[this.dataTypeComparatorsKeys[0]].handle;
            } else {
                this.activeCondition.comparatorHandle = null;
            }
        },

        getLabel () {

            if(this.customTypeConditionComponent && this.$refs.customCondition) {
                return this.$refs.customCondition.getLabel();
            }

            let field = this.activeField ? this.activeField.name : null;
            let comparator = this.activeComparator ? this.activeComparator.label : null;
            let value = this.activeCondition.condition.value;

            if(!this.valueComponent) {
                return `${field} : ${comparator}`;
            }

            if(this.$refs.valueComponent && this.$refs.valueComponent.getLabel) {
                value = this.$refs.valueComponent.getLabel();
            } else if(this.activeField && this.activeField.options) {
                const opt = this.activeField.options.find(o => o.value === value);
                if(opt) {
                    value = opt.label;
                }
            }

            if(this.activeComparator && this.activeComparator.hideLabel) {
                return `${field} ${value}`;
            } else if(this.valueComponent !== null) {
                return `${field} ${comparator} ${value}`;
            } else {
                return `${field} ${comparator}`;
            }

        },

    },
}
</script>

<style lang="scss" scoped>
    .condition {
        margin:10px 0;
    }
    .select-a-field {
        margin-top:6px;
    }
</style>
